import { Contract, Seller } from '@/types/ContractType';
import { rtkApi } from '../rtkApi';

export const sellerApi = rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    getSellerByID: builder.query<Seller, string>({
      query: (sellerId) => ({ url: `/seller/${sellerId}` }),
      providesTags: (_response, _result, sellerId) => [
        { type: 'Seller', id: sellerId },
      ],
    }),
    addSellerContractByID: builder.mutation<
      Seller,
      { sellerId: string; contractId: string }
    >({
      query: ({ sellerId, contractId }) => ({
        url: `/seller/add-contract/${sellerId}`,
        method: 'POST',
        data: { contractId },
      }),
      invalidatesTags: (_response, _result, { sellerId }) => [
        { type: 'Seller', id: sellerId },
      ],
    }),
    getSellerContractByID: builder.query<Seller, string>({
      query: (sellerId) => ({ url: `/seller/contract/${sellerId}` }),
      providesTags: (_response, _result, sellerId) => [
        { type: 'Seller', id: sellerId },
      ],
    }),
    getAllSellerContracts: builder.query<Contract[], string>({
      query: (sellerId) => ({ url: `/seller/all-contracts/${sellerId}` }),
      providesTags: (_response, _result, sellerId) => [
        { type: 'Seller', id: sellerId },
      ],
    }),
  }),
});

export const {
  useGetSellerByIDQuery,
  useAddSellerContractByIDMutation,
  useGetSellerContractByIDQuery,
  useGetAllSellerContractsQuery,
} = sellerApi;
